import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, Typography, Tooltip, FormLabel, RadioGroup, TextField } from '@material-ui/core';
import _ from 'lodash';
import OverLoading from '../global/OverLoading';
import AdsTable from './table';
import Constants, { Colours } from '../../common/constants';
import { addAd, getAds, updateDisplayOrder } from '../../actions/admin/advertisementAction';
import Sortable from './sort/sortable';

const AdsList = ({ match, addAd, getAds, updateDisplayOrder }) => {
  const [ads, setAds] = React.useState([]);
  const [adType, setAdType] = React.useState('URL');
  const [mapType, setMapType] = React.useState(Constants.MapType.Food);
  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [redirectUrl, setRedirectUrl] = React.useState(null);
  const [refresh, setRefresh] = React.useState(false);
  const [sorted, setSorted] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [customAdType, setCustomAdType] = React.useState('');
  const [showCustomAdsInput, setShowCustomAdsInput] = React.useState(false);
  const [showMapTypes, setShowMapTypes] = React.useState(false);

  const useStyles = makeStyles(() => ({
    modal: {
      height: '80vh',
    },
  }));
  const classes = useStyles();

  const fetchAdvertisements = async () => {
    try {
      setLoading(true);
      // for sorting ads we should fetch all the rows
      // pageSize set to 100
      const res = await getAds({ pageSize: 100, pageNo: 0 });
      if (res.totalCount > 0) {
        setAds(_.orderBy(res.rows, 'displayOrder'));
        setLoading(false);
      } else {
        setAds([]);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  useEffect(() => {
    if (refresh) {
      fetchAdvertisements();
    }
    setRefresh(false);
  }, [refresh]);

  useEffect(() => {
    if (adType === Constants.AdType.Custom) {
      setShowCustomAdsInput(true);
      setShowMapTypes(false);
    } else if (adType === Constants.AdType.MapScreen) {
      setShowMapTypes(true);
      setShowCustomAdsInput(false);
    } else {
      setShowCustomAdsInput(false);
      setShowMapTypes(false);
    }
  }, [adType]);

  const handleOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setRefresh(true);
  };

  const handleChange = (event) => {
    switch (event.target.name) {
      case 'adType':
        setAdType(event.target.value);
        break;
      default:
    }
  };

  const handleMapTypeChange = (event) => {
    switch (event.target.name) {
      case 'mapType':
        setMapType(event.target.value);
        break;
      default:
    }
  };

  const handleCustomAdsTypeText = (e) => {
    const text = e.target.value;
    setCustomAdType(text);
  };

  const onAddAd = async () => {
    try {
      const payload = {
        type:         ((adType === Constants.AdType.Custom) ? customAdType : adType),
        displayOrder: ads.length + 1,
        params:       ((adType === Constants.AdType.MapScreen) ? { mapType } : {}),
      };
      const ad = await addAd(payload);
      if (ad) {
        toast.success('Advertisement created.');
        setRedirectUrl(`/admin/advertisement/${ad.id}`);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleOpenEdit = () => {
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const onEditOrder = async () => {
    try {
      const order = sorted.map((a) => a.id);
      const res = await updateDisplayOrder(order);
      if (res) {
        toast.success('Display order updated.');
        setRefresh(true);
      }

      handleCloseEdit();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSort = (data) => {
    setSorted(data);
  };

  if (redirectUrl) { return (<Redirect to={redirectUrl} />); }
  return (
    <>
      { loading && <OverLoading /> }
      <div>
        <div className="content-header">
          <h1>Advertisements</h1>
          <div>
            <Button onClick={handleOpenAdd} variant="contained">Add</Button>
            {' '}
            {ads.length > 1
              ? <Button onClick={handleOpenEdit} variant="contained">Edit Display Order</Button>
              : (
                <Tooltip title="Insufficient Highlights">
                  <span>
                    <Button disabled variant="contained">Edit Display Order</Button>
                  </span>
                </Tooltip>
              )}
          </div>
        </div>

        {!refresh && <AdsTable callback={() => setRefresh(true)} />}

        <Dialog fullWidth maxWidth="md" open={openAdd} onClose={handleCloseAdd} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Add Advertisement</DialogTitle>
          <DialogContent>
            <div style={{ marginTop: 15 }}>
              <Typography variant="h5">Select</Typography>
              <FormLabel component="legend" style={{ color: Colours.Black, marginTop: 15 }}>Advertisement Type</FormLabel>
              <RadioGroup
                row
                aria-label="adType"
                name="adType"
                value={adType}
                onChange={(e) => handleChange(e)}
              >
                <FormControlLabel
                  value={Constants.AdType.Url}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Url}
                />
                <FormControlLabel
                  value={Constants.AdType.Post}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Post}
                />
                <FormControlLabel
                  value={Constants.AdType.MediaOnly}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.MediaOnly}
                />
                <FormControlLabel
                  value={Constants.AdType.Stickers}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Stickers}
                />
                <FormControlLabel
                  value={Constants.AdType.Page}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Page}
                />
                <FormControlLabel
                  value={Constants.AdType.Highlight}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Highlight}
                />
                <FormControlLabel
                  value={Constants.AdType.MapScreen}
                  control={<Radio color="primary" />}
                  label="Map"
                />
                <FormControlLabel
                  value={Constants.AdType.Custom}
                  control={<Radio color="primary" />}
                  label={Constants.AdType.Custom}
                />
              </RadioGroup>

              {showCustomAdsInput
              && (
                <>
                  <FormLabel className="mt-2" component="legend" style={{ color: Colours.Black }}>
                    Enter Custom Type
                    {'  '}
                    <span style={{ color: Colours.Red }}>* required</span>
                  </FormLabel>
                  <TextField name="description" variant="outlined" className="d-flex col-12 col-md-8 col-lg-6" size="small" value={customAdType} onChange={(e) => handleCustomAdsTypeText(e)} />
                </>
              ) }

              { showMapTypes && (
                <div style={{ marginTop: 15 }}>
                  <Typography variant="h5">Select Map</Typography>

                  <RadioGroup
                    row
                    aria-label="mapType"
                    name="mapType"
                    value={mapType}
                    onChange={(e) => handleMapTypeChange(e)}
                  >
                    <FormControlLabel
                      value={Constants.MapType.Food}
                      control={<Radio color="primary" />}
                      label={Constants.MapType.Food}
                    />
                    <FormControlLabel
                      value={Constants.MapType.Deal}
                      control={<Radio color="primary" />}
                      label={Constants.MapType.Deal}
                    />
                  </RadioGroup>
                </div>
              ) }
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAdd} color="primary">Cancel</Button>
            <Button onClick={onAddAd} color="primary">Add</Button>
          </DialogActions>
        </Dialog>

        <Dialog classes={{ paper: classes.modal }} fullWidth maxWidth="sm" open={openEdit} onClose={handleCloseEdit} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Edit Display Order</DialogTitle>
          <DialogContent id="form-dialog-content">
            <Sortable ads={_.sortBy(ads, ['displayOrder'], ['asc'])} handleSort={handleSort} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="primary">Cancel</Button>
            <Button onClick={onEditOrder} color="primary">Update</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default connect(null, { addAd, getAds, updateDisplayOrder })(AdsList);
